import { env } from "@/env";

import { ChainName } from "./chains";

export const RPC_URLS: Record<ChainName, string> = {
  Ethereum:
    env.NEXT_PUBLIC_ETHEREUM_RPC_URL ||
    "https://rpc.ankr.com/eth/ccab7c7aac640453c6c656b37e5688f307359fc0165f9c2355c5661662fae49e",
  Arbitrum:
    env.NEXT_PUBLIC_ARBITRUM_RPC_URL ||
    "https://rpc.ankr.com/arbitrum/ccab7c7aac640453c6c656b37e5688f307359fc0165f9c2355c5661662fae49e",
  Base:
    env.NEXT_PUBLIC_BASE_RPC_URL ||
    "https://rpc.ankr.com/base/ccab7c7aac640453c6c656b37e5688f307359fc0165f9c2355c5661662fae49e",
  Solana: env.NEXT_PUBLIC_SOLANA_RPC_URL || "https://loni-kx8vfe-fast-mainnet.helius-rpc.com",
  // Sui's public fullnodes dropped JSON-RPC entirely — `fullnode.mainnet.sui.io`, which this used
  // to point at, answers every method with -32601 and a pointer at gRPC/GraphQL. We cannot follow
  // that migration: `@aptos-labs/cross-chain-core` pins `@mysten/sui` 1.x, whose `SuiClient` is
  // JSON-RPC only. So this has to name a provider that still serves the old transport.
  Sui: env.NEXT_PUBLIC_SUI_RPC_URL || "https://sui-rpc.publicnode.com",
  Aptos: env.NEXT_PUBLIC_APTOS_RPC_URL || "https://fullnode.mainnet.aptoslabs.com/v1", // public node for now switch to private node later
  Sepolia: "https://ethereum-sepolia.publicnode.com",
  ArbitrumSepolia: "https://sepolia-rollup.arbitrum.io",
  BaseSepolia: "https://sepolia.base.org/",
};

/**
 * Sui testnet, which `ChainName` has no member for (the testnet entries there are EVM only).
 *
 * Needed because cross-chain-core's *testnet* default is `fullnode.testnet.sui.io`, deprecated in
 * exactly the same way as its mainnet sibling — so unlike the EVM chains, whose library defaults
 * still work off-mainnet, Sui has to be overridden on both networks.
 */
export const SUI_TESTNET_RPC_URL = "https://sui-testnet-rpc.publicnode.com";

export const getRpcUrlForChain = (chainName: ChainName) => {
  return RPC_URLS[chainName];
};
